import { render, staticRenderFns } from "./DecimalComponent.vue?vue&type=template&id=1960e531&"
import script from "./DecimalComponent.vue?vue&type=script&lang=ts&"
export * from "./DecimalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports